import {PermissionNameFor} from '@/components/permissions/Permission.tsx';
import {Resource} from '@/components/permissions/Resource.tsx';
import {Action} from '@/components/permissions/Action.tsx';


export function fetchRoutesFromApi() {
    if (window.location.hostname === 'standalone.saas.test.krzepicki.pl') {
        return Promise.resolve([
            {
                path: '/',
                layout: 'EmptyLayout',
                children: [
                    {path: null, element: 'IdCard', index: true},
                ]
            },
        ]);
    }

    return Promise.resolve([
        {
            path: '/',
            layout: 'EmptyLayout',
            children: [
                {path: 'login', element: 'SignInPage', index: false},
                {path: 'create-account', element: 'CreateAccountPage', index: false},
                {path: '404', element: 'NotFound', index: false},
                {path: '*', element: 'Redirect404', index: false}
            ]
        },
        {
            path: '/',
            layout: 'HomepageLayout',
            children: [
                {path: null, element: 'LandingPage', index: true},
                {path: 'company/:companyId', element: 'IdCard', index: true},
            ]
        },
        {
            path: '/dashboard',
            layout: 'MainLayout',
            element: 'ProtectedRoute',
            requiredPermission: PermissionNameFor(Resource.Dashboard, Action.View),
            children: [
                {path: null, element: 'DashboardPage', index: true},
                {path: 'my-profile', element: 'Profile'},
                {path: 'settings', element: 'Settings', index: true},
                {path: 'idcard/edit', element: 'IdCardEdit', index: true},
                {path: 'idcard/preview', element: 'IdCardPreview', index: true},
                {path: 'website/list', element: 'WebsiteList', index: true},
                {path: 'website/create', element: 'WebsiteCreate', index: true}
            ]
        },
        {
            path: '/admin',
            layout: 'MainLayout',
            element: 'ProtectedRoute',
            children: [
                {path: 'routes-helper', element: 'AdminRoutesHelper', index: false}
            ]
        }
    ]);
}
